var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 10,
    viewBox: "0 0 319.55 319.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n        fill: #FFB85C;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.03,159.8c0-28.94-.07-57.88.02-86.83C.15,41.56,17.76,15.62,46.16,4.69,54.52,1.46,63.19.06,72.11.06c58.38-.01,116.77-.15,175.15.05,35.21.12,63.14,22.67,70.64,56.73,1.19,5.42,1.55,11.13,1.56,16.7.11,57.51.11,115.02.05,172.53-.04,36.05-22.2,64.2-56.68,71.83-5.42,1.2-11.12,1.57-16.69,1.58-57.63.11-115.27.12-172.9.05-35.82-.04-64.22-22.56-71.65-56.94-1.2-5.55-1.47-11.38-1.5-17.08-.14-28.57-.07-57.13-.07-85.7ZM263.13,159.68c-.04-56.92-46.36-103.2-103.31-103.22-57.13-.01-103.45,46.35-103.41,103.48.04,56.91,46.37,103.19,103.3,103.21,57.14.01,103.45-46.32,103.42-103.47ZM265.39,31.6c-12.16.01-21.85,9.7-21.81,21.81.04,11.8,9.81,21.61,21.66,21.75,12,.14,21.9-9.71,21.9-21.78,0-12.26-9.52-21.78-21.76-21.77Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.44,159.83c-.03,32.4-26.41,58.74-58.75,58.65-32.43-.08-58.6-26.42-58.48-58.86.12-32.39,26.12-58.34,58.5-58.39,32.46-.05,58.76,26.19,58.73,58.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.6956ddedad16655631aaf9a7d5de8516.svg";
export { ForwardRef as ReactComponent };